// extracted by mini-css-extract-plugin
export var collapsedSummary = "_r2-0";